<template>
  <div class="psConfigurationPhases">
    <ps-upper-bar :site="{ site: 'Configuración - Fases' }" :backButton="true"></ps-upper-bar>
    <div class="container">
      <div class="row">
        <el-button round plain icon="el-icon-plus" @click="addNewPhase" :disabled="newPhase">Nueva fase</el-button>
      </div>
      <div class="row rowData">
        <div class="column w-25">
          <div class="label">Descripcion</div>
          <el-input 
            :value="phase.phaseDescription" 
            @input="changeProperty($event, 'phaseDescription')" 
            placeholder="Ingrese una descripción"
            :disabled="!newPhase"></el-input>
        </div>
        <div class="column">
          <div class="label">Administradora</div>
          <el-select :value="phase.user" @change="changeProperty($event, 'user')" :disabled="!newPhase">
            <el-option v-for="(user, index) in users.filter(u => u.roleId == 1)" :key="index" :value="user" >{{user.name}} {{user.surname}}</el-option>
          </el-select>
        </div>
        <div class="column">
          <div class="label">Días eventos</div>
          <el-input-number 
            :value="phase.eventsDays" 
            @input="changeProperty($event, 'eventsDays')" 
            :disabled="!newPhase"
            :min="0"
            :controls="false"
          />
        </div>        
        <div class="column">
          <div class="label">Activa</div>
          <el-switch :value="phase.active" @input="changeProperty($event, 'active')" :disabled="!newPhase"></el-switch>
        </div>
      </div>
      <div class="row rowButtons">
        <el-button round plain type="success" :disabled="!saveDisabled" @click="save">Guardar</el-button>
        <el-button round plain type="danger" :disabled="!newPhase" @click="cancelPhase">Cancelar</el-button>
      </div>

      <el-table 
        :data="phases"
        style="width: 800px;" 
        :highlight-current-row="true" 
        size="mini" 
        height="200" 
        empty-text="No hay tarifas ingresadas"
        @cell-dblclick="selectRow">
        <el-table-column prop="phaseId" label="Código" width="80" class-name="phaseId" id="phaseId" v-if="!isMobile"></el-table-column>
        <el-table-column prop="phaseDescription" label="Descripción" :width="isMobile == true ? '' : 200" ></el-table-column>
        <el-table-column prop="user" label="Administradora" :width="isMobile == true ? '' : 120" ></el-table-column>
        <el-table-column prop="eventsDays" label="Días eventos" :width="isMobile == true ? '' : 200" ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import PsUpperBar from '@/components/layout/PsUpperBar.vue'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PsConfigurationPhases',
  components: { PsUpperBar },
  data () {
    return {
      activeNames: [],
      newPhase: false
    }
  },
  computed: {
    ...mapState(['isMobile']),
    ...mapState('phases', ['phases', 'phase', 'errors']),
    ...mapState('users', ['users']),
    saveDisabled () {
      return this.newPhase && this.phase.phaseDescription != '' 
    }
  },
  methods: {
    ...mapMutations('phases', ['PHASES_PHASE', 'PHASES_PHASE_PROP']),
    ...mapActions('phases', ['savePhase', 'getPhasesHTTP']),
    ...mapActions('users', ['getUsersHTTP']),
    formatMoney ( row, column, cellValue ) {
      return `$ ${cellValue}`
    },
    selectRow ( row ) {
      if( row ) {
        this.activeNames = []
        this.newPhase = true
        this.PHASES_PHASE(JSON.parse(JSON.stringify(row)))
      }
    },
    changeProperty ( value, property ) {
      if(property == 'user') {
        this.PHASES_PHASE_PROP({property: 'userId', value: value.userId} )
        this.PHASES_PHASE_PROP({property: 'user', value: `${value.name} ${value.surname}`} )
      } else {
        this.PHASES_PHASE_PROP({property, value})
      }
    },
    addNewPhase () {
      this.newPhase = true
      this.PHASES_PHASE({})
    },
    cancelPhase () {
      this.newPhase = false
      this.PHASES_PHASE({})
    },
    async save () {
      let loading
      try {
        loading = this.$loading({
          lock: true,
          text: 'Guardando...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        }); 

        const message = await this.savePhase()
        if(this.errors.length > 0 ) {
          this.showValidationAlert()
        } else {
          this.cancelPhase()
          this.$message( { message, type: 'success' } )
          this.getPhasesHTTP()
          this.cancelPhase()
        }
    } catch ( err ) {  this.$message( { message: err.response.data.err.details, type: 'error' })}
      finally { loading.close(); }
    },
    showValidationAlert () {      
      let str = '<p>';
      if(this.errors.length > 0) {
        this.errors.forEach(err => str += `${err}<br>`)
        str = str + '</p>'
        this.$alert(str, '', {confirmButtonText: 'Entendido', type: 'warning', dangerouslyUseHTMLString: true})
      }
    },
  },
  created () {
    this.PHASES_PHASE({})
    this.getPhasesHTTP()
    this.getUsersHTTP()
  }
}
</script>

<style scoped>
  .psConfigurationPhases { min-height: 90%;}
  .container { background-color: white; border-radius: 20px; padding: 32px; min-height: 90%; overflow-y: scroll; height: 100%; }
  .container::-webkit-scrollbar { display: none}
  .rowData { margin: 40px 0 20px}
  .rowHistory { margin-bottom: 20px;}
  .el-collapse { width: 500px }
  .itemHistoryRate { text-align: left;}
  .stateRate { color: red; margin-left: 15px}
  .active { color: green}


  /* Medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
    .container { padding: 32px 16px}
    .rowData { flex-direction: column;}
    .rowData .column { margin-right: 0 }
    .rowData .column .el-input-number, .rowData .w-25 { width: 100%; margin-bottom: 8px; }
    .rowButtons { justify-content: space-evenly;}
  }
</style>